import classOnBtn from "../../../assets/images/classes/menu_class_on.svg"
import classOffBtn from "../../../assets/images/classes/menu_class_off.svg"
import studentOnBtn from "../../../assets/images/classes/menu_students_on.svg"
import studentOffBtn from "../../../assets/images/classes/menu_students_off.svg"
import qrCodeOnBtn from "../../../assets/images/classes/menu_qr_on.svg"
import qrCodeOffBtn from "../../../assets/images/classes/menu_qr_off.svg"
import accountLinkOnBtn from "../../../assets/images/classes/menu_link_on.svg"
import accountLinkOffBtn from "../../../assets/images/classes/menu_link_off.svg"
import repeatBlueIcon from "../../../assets/images/Repeat_blue.png"
import repeatGrayIcon from "../../../assets/images/Repeat_gray.png"
import {useEffect, useState} from "react";
import Modal from "../../../components/Modal";
import Button from "./Button";
import {cloneDeep} from "lodash";
import TabButton from "../../../components/TabButton";
import {messageToast} from "../../../components/Toast";


const ManagementNavigation = ({activeTab, setActiveTab, isEditable, setIsEditable, setClasses, savedClasses, setStudents, savedStudents, updateClassesInfo,setUpdateClassesInfo, updateStudentInfo, setUpdateStudentInfo, fetchUpdateClasses, fetchUpdateStudents, isModStudentConsent, setIsModStudentConsent}) => {
    const [saveTab, setSaveTab] = useState(false);
    const [isModifyCheckModalOpen, setIsModifyCheckModalOpen] = useState(false);

    // 연동 대상 년도 계산 (3월 1일 이후면 작년, 3월 1일 전이면 재작년)
    const now = new Date();
    const isFeb1OrLater = now.getMonth() >= 1; // getMonth()는 0부터 시작, 1 = 2월
    const lastYear = now.getFullYear() - (isFeb1OrLater ? 1 : 2);

    const handleTabClick = (tab) => {
        if(isEditable){
            if(updateStudentInfo && updateStudentInfo.length>0){
                setIsModifyCheckModalOpen(true);
                setSaveTab(tab);
                return;
            }
            if(updateClassesInfo && updateClassesInfo.length>0){
                setIsModifyCheckModalOpen(true);
                setSaveTab(tab);
                return;
            }
            setIsEditable(false);
        }
        setIsModStudentConsent(false);
        setActiveTab(tab);
    };

    // 변경된 정보 수정 저장 후 동작
    const handleSaveClick = () => {
        if(isModStudentConsent){
            if(updateStudentInfo && updateStudentInfo.length>0){
                fetchUpdateStudents(true);
            }
        }else{
            messageToast({message:"학생정보 저장에 동의해주세요!",description:"동의하지 않으면 저장할 수 없습니다."});

            setIsModifyCheckModalOpen(false);
            return;
        }
        if(updateClassesInfo && updateClassesInfo.length>0){
            fetchUpdateClasses(true)
        }
        setIsModStudentConsent(false);
        setIsEditable(false);
        setIsModifyCheckModalOpen(false);
        setActiveTab(saveTab);
    }

    const noSaveChangeTab = () => {
        if(updateClassesInfo && updateClassesInfo.length>0){
            setClasses(savedClasses);
            setUpdateClassesInfo([]);
        }
        if(updateStudentInfo && updateStudentInfo.length>0){
            setStudents(savedStudents);
            setUpdateStudentInfo([]);
        }
        setIsModStudentConsent(false);
        setIsEditable(false);
        setIsModifyCheckModalOpen(false);
        setActiveTab(saveTab);
    }

    return (
        <>
            <div className="flex flex-wrap justify-center items-center mt-[60px] min-h-[52px]">
                <TabButton
                    on={classOnBtn}
                    off={classOffBtn}
                    active={activeTab==='class'}
                    line={114}
                    onClick={() => handleTabClick('class')}/>
                <div className="flex items-center gap-1.5 self-stretch my-auto font-medium whitespace-nowrap min-h-[46px] text-stone-300">ㅣ</div>
                <TabButton
                    on={studentOnBtn}
                    off={studentOffBtn}
                    active={activeTab==='student'}
                    line={100}
                    onClick={() => handleTabClick('student')}/>
                <div className="flex items-center gap-1.5 self-stretch my-auto font-medium whitespace-nowrap min-h-[46px] text-stone-300">ㅣ</div>
                <TabButton
                    on={qrCodeOnBtn}
                    off={qrCodeOffBtn}
                    active={activeTab==='qrCode'}
                    line={140}
                    onClick={() => handleTabClick('qrCode')}/>
                {/*<div className="flex items-center gap-1.5 self-stretch my-auto font-medium whitespace-nowrap min-h-[46px] text-stone-300">ㅣ</div>*/}
                {/*<button*/}
                {/*    onClick={() => handleTabClick('studentAccountLink')}*/}
                {/*    className={`flex items-center gap-2 px-4 py-2 text-[18px] font-[700]*/}
                {/*    ${activeTab === 'studentAccountLink'*/}
                {/*        ? 'mt-[2px]'*/}
                {/*        : ''*/}
                {/*    }`}*/}
                {/*>*/}
                {/*    <img*/}
                {/*        src={activeTab === 'studentAccountLink' ? repeatBlueIcon : repeatGrayIcon}*/}
                {/*        alt="학생 연동"*/}
                {/*        className="w-5 h-5"*/}
                {/*    />*/}
                {/*    <div className={` ${activeTab === 'studentAccountLink'*/}
                {/*            ? 'text-[#355BDF]'*/}
                {/*            : 'text-black opacity-30'*/}
                {/*    }`}>{lastYear}년 학생 연동</div>*/}
                {/*</button>*/}
            </div>

            {/* 정보 수정 확인 모달 */}
            <Modal
                isOpen={isModifyCheckModalOpen}
                onClose={() => setIsModifyCheckModalOpen(false)}
            >
                <h2 className="text-2xl font-bold mb-4">정보 수정</h2>
                <div className="border-[1px] bg-[#D3D3D3] w-[416px] mx-[15px]"></div>
                <p className="my-8 text-xl font-normal">변경된 내용이 있습니다.<br/>저장하시겠습니까?</p>
                <div className="flex justify-center gap-4">
                    <Button
                        label="아니요"
                        className="bg-[#BFBFBF] text-black hover:bg-gray-400"
                        onClick={() => noSaveChangeTab()}
                    />
                    <Button label="저장하기" onClick={handleSaveClick}/>
                </div>
            </Modal>
        </>
    )
}


export default ManagementNavigation;